import { h } from 'preact';

const getSizedImageUrl = (src, size) => {
  if (size === null) return src;
  if (!src) return false;
  const match = src.match(
    /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i,
  );
  if (!match) return null;
  const prefix = src.split(match[0])[0];
  const suffix = match[0];
  
  // Handle edge case where image is hosted on Shopify CDN and resizing has to be done differently
  if (src.includes('cdn.shopify.com')) {
    return `${prefix}?width=${size}&height=${size}&crop=center&${suffix}`;
  }
  return `${prefix}_${size}x${suffix}`.replace(/http(s)?:/, '');
};

const Image = ({
  alt,
  src,
  srcWidths = {},
  height,
  width,
  classes = '',
  loading = 'lazy',
  isCustomMetafieldImage = false,
}) => {
  const bps = { sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 };
  const widths = { ...srcWidths };

  // Remove undefined breakpoints
  Object.keys(bps).forEach((key) => {
    if (widths[key] === undefined) {
      delete bps[key];
    }
  });

  // Reduce to values arrays
  const srcWidthsReduced = Object.values(widths).filter(Boolean);
  const sizeWidthsReduced = Object.values(bps).filter(Boolean);

  // Convert to srcSet and sizes values
  const srcsetFormatted = isCustomMetafieldImage
    ? `${src} 1x` // Directly use the src for custom metafield images without modification
    : srcWidthsReduced.map((w) => `${getSizedImageUrl(src, w)} ${w}w`).join(',');

  const sizesFormatted = sizeWidthsReduced
    .map((w, i) => `(max-width: ${w}px) ${srcWidthsReduced[i]}px`)
    .join(', ');

  const altText = alt || '';
  const altParts = altText.split(" | ");
  const altPart = altParts[0];

  return (
    <img
      className={`image ${classes}`}
      srcSet={srcsetFormatted}
      sizes={sizesFormatted}
      src={src}
      alt={altPart || ''}
      height={height}
      width={width}
      loading={loading}
    />
  );
};

export default Image;
